const pluralize = (label, length) => `${label}${length > 1 ? 's' : ''}`

export const getFormattedDuration = (unit, length) => {
  if (unit === 'days') return `${length} ${pluralize('day', length)}`
  if (unit === 'years') return `${length} ${pluralize('year', length)}`
  // Today even if we set unit as years recurly is returning the duration as months
  const isYear = !!(length && (length % 12) === 0)
  if (isYear) {
    const years = length / 12
    return `${years} ${pluralize('year', years)}`
  }
  return `${length} ${pluralize('month', length)}`
}

export const getFormattedCycleLength = (length) => {
  const isYear = !!(length && (length % 12) === 0)
  if (isYear) {
    return 'year'
  }
  return 'month'
}

export const formatAmount = (currency, price) => {
  if (!currency) {
    return ''
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency
  }).format(price)
}
